import getSearchResults from "api/requests/getSearchResults";
import { NextPageContext } from "next";
import { Coordinates } from "custom-types/Coordinates";

import { Brand } from "custom-types/Brand";
import { Dispensary } from "custom-types/Dispensary";
import { Strain } from "custom-types/Strain";
import { Article } from "custom-types/Article";
import { MenuItem } from "custom-types/MenuItem";
import { SearchPageTypes } from "custom-types/Search";

export const MAX_DISTANCE = 30; // 30 miles

export type SearchState = {
  loading: boolean;
  article: Article[];
  brand: Brand[];
  dispensary: Dispensary[];
  menuItem: MenuItem[];
  strain: Strain[];
  menuItemCategories: string[];
  menuItemDispensaries: Dispensary[];
  categoryRelevanceOrder: SearchPageTypes[];
};

export type SearchResults = Omit<SearchState, "loading">;

export const initialState: SearchState = {
  loading: false,
  article: [],
  brand: [],
  dispensary: [],
  menuItem: [],
  strain: [],
  menuItemCategories: [],
  menuItemDispensaries: [],
  categoryRelevanceOrder: [
    "strain",
    "menuItem",
    "dispensary",
    "brand",
    "article",
  ],
};

export const SEARCH_LOADING = "SEARCH_LOADING";
export const SEARCH_RESULTS = "SEARCH_RESULTS";
export const SEARCH_LOAD_MORE = "SEARCH_LOAD_MORE";

export type SearchLoadingAction = {
  type: typeof SEARCH_LOADING;
};

export type SearchResultsAction = {
  type: typeof SEARCH_RESULTS;
  results: SearchResults;
};

export type SearchLoadMoreAction = {
  type: typeof SEARCH_LOAD_MORE;
  result: Partial<SearchResults>;
};

export type SearchActions =
  | SearchLoadingAction
  | SearchResultsAction
  | SearchLoadMoreAction;

export const getSearchState = async (
  ctx: NextPageContext,
  coordinates: Coordinates,
  countryCode: string
) => {
  const {
    query: { q },
    store: { dispatch },
  } = ctx;

  const results = await getSearchResults(
    { q },
    coordinates,
    MAX_DISTANCE,
    countryCode
  );

  dispatch<SearchResultsAction>({
    type: SEARCH_RESULTS,
    results,
  });
};

export const searchReducer = (
  state = initialState,
  action: SearchActions
): SearchState => {
  switch (action.type) {
    case SEARCH_LOADING:
      return {
        ...state,
        loading: true,
      };
    case SEARCH_RESULTS:
      return {
        ...state,
        loading: false,
        ...action.results,
      };
    case SEARCH_LOAD_MORE:
      return {
        ...state,
        ...action.result,
      };
    default:
      return state;
  }
};

export default searchReducer;
